import { getStandaloneComponentRenderer, HeaderLogoOnly } from "@kaltura/mediaspace-shared-layout";

export const Component = HeaderLogoOnly;

export const render = getStandaloneComponentRenderer(HeaderLogoOnly, true);
